import Button from "@components/Button";
import { useGetPatientVisit } from "@app/services/omr-service";
import { formatNumber } from "@app/utils";
import Input from "@app/components/Input";
import Label from "@app/components/Label";
import TextArea from "@app/components/TextArea";
import InputDate from "@app/components/InputDate";
import { useState } from "react";
import ReactSelect from "@app/components/ReactSelect";

// const InputFileCustom = () => {
//   const [files, setFiles] = useState([]);

//   return (
//     <div className="bg-white p-1.5 focus:border border-blueGray-300 border-2 rounded text-gray-800">
//       <input type="file" className="appearance-none text-sm text-gray-800" />
//     </div>
//   );
// };

export const AddNews = () => {
  const { data, isFetching, isLoading, payload, setPayload, refetch } =
    useGetPatientVisit({ patient_type: "out-patient" });
  const [selectedDay, setSelectedDay] = useState(null);

  let dataStatus = [
    { value: "ocean", label: "Ocean", color: "#00B8D9", isFixed: true },
    { value: "blue", label: "Blue", color: "#0052CC", isDisabled: true },
    { value: "purple", label: "Purple", color: "#5243AA" },
    { value: "red", label: "Red", color: "#FF5630", isFixed: true },
    { value: "orange", label: "Orange", color: "#FF8B00" },
    { value: "yellow", label: "Yellow", color: "#FFC400" },
    { value: "green", label: "Green", color: "#36B37E" },
    { value: "forest", label: "Forest", color: "#00875A" },
    { value: "slate", label: "Slate", color: "#253858" },
    { value: "silver", label: "Silver", color: "#666666" },
  ];

  return (
    <div>
      <div className="flex flex-row">
        <h1 className="text-2xl">Tambah Informasi Terbaru</h1>
      </div>
      <div className="mt-6 border-2 border-gray-300 rounded-xl px-4 py-6">
        <div className="grid grid-cols-3 gap-5">
          {/* //! bagian kiri */}
          <div className="grid grid-cols-2 gap-5 col-span-2">
            <div>
              <Label size="sm" font="bold">
                Judul
              </Label>
              <Input placeholder="Masukkan Judul" />
            </div>

            <div>
              <Label size="sm" font="bold">
                Kategori
              </Label>
              <ReactSelect
                placeholder="Pilih Kategori..."
                options={dataStatus}
                zIndex={1000}
              >
                <option value="hurr">Durr</option>
                <option value="hurr">Durr</option>
                <option value="hurr">Durr</option>
                tes
                <div>res</div>
              </ReactSelect>
            </div>

            <div>
              <Label size="sm" font="bold">
                Detail Informasi
              </Label>
              {/* <InputFileCustom /> */}
              <TextArea
                rows="5"
                placeholder="Masukkan Detail Informasi"
              ></TextArea>
            </div>

            <div>
              <Label size="sm" font="bold">
                Foto Informasi Terbaru
              </Label>
              <Input placeholder="tes" type="file" />
            </div>
          </div>

          {/* //! Bagian Kanan */}
          <div>
            <Label size="sm" font="bold">
              Tag
            </Label>
            <TextArea rows="5" placeholder="Masukkan Tag"></TextArea>
          </div>
        </div>
        {/* //! end grid */}

        <div className="flex flex-row-reverse mt-4">
          <div className="flex flex-row">
            <div className="mr-3 w-[130px] ">
              <Button
                variant="outline"
                color="red"
                block
                onClick={() => alert()}
              >
                Batal
              </Button>
            </div>
            <div className=" w-[130px]">
              <Button
                variant="solid"
                color="blue"
                block
                onClick={() => alert()}
              >
                Simpan
              </Button>
            </div>
          </div>
        </div>
      </div>
      <div className="flex flex-row-reverse mt-4">
        <div className="flex flex-row">
          <div className="mr-3 w-[160px] ">
            <Button variant="outline" color="red" block onClick={() => alert()}>
              Unpublish
            </Button>
          </div>
          <div className=" w-[160px]">
            <Button variant="solid" color="blue" block onClick={() => alert()}>
              Publish
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};
``;
